import { Group } from '@mui/icons-material'
import { Typography } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2/Grid2'
import { VisitantesContext } from '../../../../Providers/VisitantesContext/VisitantesContext'
import { useContext } from 'react'
import CardVisitanteSelecionado from '../CardVisitanteSelecionado/CardVisitanteSelecionado'

const VisitantesSelecionados = ({ modifyDisabled }) => {
    const { visitantesSelecionados } = useContext(VisitantesContext)

    return (
        <Grid sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '20%',
            height: '100%',
            padding: '3px',
            flexWrap: 'wrap',
            overflowY: 'scroll',
            alignItems: 'center'
        }}>
            <Grid sx={{
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
                height: '10%',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <Group sx={{ ...TypographySx, fontSize: '15px' }}/>
                <Typography sx={{ ...TypographySx, marginLeft: '5px' }}>
                    Visitantes Adicionados:
                </Typography>
            </Grid>
            <Grid sx={{
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
                height: '80%',
                alignItems: 'flex-start',
                justifyContent: 'center',
                flexWrap: 'wrap',
                overflowY: 'scroll'
            }}>
                {visitantesSelecionados && visitantesSelecionados.length > 0
                    ? (
                        visitantesSelecionados.map((pessoa, index) => {
                            return <CardVisitanteSelecionado pessoa={pessoa} key={index} modifyDisabled={modifyDisabled}/>
                        })
                    )
                    : (
                        <div>
                            <Typography sx={{ ...TypographySx, fontSize: '13px' }}>
                    Nenhum visitante selecionado!
                            </Typography>
                        </div>
                    )
                }
            </Grid>
        </Grid>
    )
}

export default VisitantesSelecionados

const TypographySx = {
    color: 'black',
    fontWeight: 700,
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '13px'
}
